/* DIRT. redesign global behaviors: scroll-reveal, mobile nav toggle, mega-menu a11y.
   Vanilla, no deps. Honors prefers-reduced-motion. Safe to load site-wide:
   every hook is opt-in via data-attributes only present on redesigned markup. */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Scroll reveal: elements with [data-r] (inside .dirt) or [data-dirt-r]
  function initReveal() {
    var els = document.querySelectorAll('.dirt [data-r], [data-dirt-r]');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  // Mobile nav: toggle [data-open] on the nearest [data-dirt-nav] via [data-dirt-nav-toggle].
  // SINGLE source of truth for the header hamburger. Per-section inline handlers were
  // removed because they double-bound this same toggle (open + immediately close).
  function initNav() {
    function setNavState(nav, open, returnFocus) {
      if (!nav) return;
      var toggle = nav.querySelector('[data-dirt-nav-toggle]');
      var menu = nav.querySelector('.nav__mobile');
      nav.toggleAttribute('data-open', open);
      document.documentElement.toggleAttribute('data-dirt-nav-open', open);
      if (toggle) {
        toggle.setAttribute('aria-expanded', String(open));
        toggle.setAttribute('aria-label', open ? 'Menu sluiten' : 'Menu openen');
      }
      if (menu) menu.setAttribute('aria-hidden', String(!open));
      if (open) {
        requestAnimationFrame(function () { sizeOpenNav(nav); });
      } else {
        nav.style.removeProperty('--nav-mobile-max-height');
        if (returnFocus && toggle) toggle.focus();
      }
    }

    function sizeOpenNav(nav) {
      if (!nav || !nav.hasAttribute('data-open')) return;
      var menu = nav.querySelector('.nav__mobile');
      if (!menu) return;
      var viewportHeight = window.visualViewport ? window.visualViewport.height : window.innerHeight;
      var available = Math.max(96, Math.floor(viewportHeight - menu.getBoundingClientRect().top - 12));
      nav.style.setProperty('--nav-mobile-max-height', available + 'px');
    }

    document.addEventListener('click', function (ev) {
      var t = ev.target.closest('[data-dirt-nav-toggle]');
      if (t) {
        var nav = t.closest('[data-dirt-nav]');
        if (nav) setNavState(nav, !nav.hasAttribute('data-open'), false);
        return;
      }
      // Click outside an open nav closes it (links inside navigate away on their own).
      var openNav = document.querySelector('[data-dirt-nav][data-open]');
      if (openNav && !ev.target.closest('[data-dirt-nav]')) {
        setNavState(openNav, false, false);
      }
    });
    document.addEventListener('keydown', function (ev) {
      if (ev.key === 'Escape') {
        var nav = document.querySelector('[data-dirt-nav][data-open]');
        if (nav) setNavState(nav, false, true);
      }
    });

    function syncNavViewport() {
      document.querySelectorAll('[data-dirt-nav][data-open]').forEach(function (nav) {
        if (window.innerWidth > 1120) {
          var menu = nav.querySelector('.nav__mobile');
          var focusWasInMenu = menu && menu.contains(document.activeElement);
          setNavState(nav, false, false);
          if (focusWasInMenu) {
            var logo = nav.querySelector('.nav__logo');
            if (logo) logo.focus();
          }
        } else {
          sizeOpenNav(nav);
        }
      });
    }

    window.addEventListener('resize', syncNavViewport, { passive: true });
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', syncNavViewport, { passive: true });
    }
  }

  function initHeaderMetrics() {
    var nav = document.querySelector('[data-dirt-nav]');
    var header = nav && nav.closest('[id^="shopify-section-"]');
    var bar = nav && nav.querySelector('.nav__inner');
    if (!header || !bar) return;

    function publishHeight() {
      var headerTop = header.getBoundingClientRect().top;
      var navStyle = window.getComputedStyle(nav);
      var paddingBottom = parseFloat(navStyle.paddingBottom) || 0;
      var height = Math.ceil(bar.getBoundingClientRect().bottom - headerTop + paddingBottom);
      document.documentElement.style.setProperty('--dirt-header-offset', height + 'px');
    }

    publishHeight();
    if ('ResizeObserver' in window) {
      var observer = new ResizeObserver(publishHeight);
      observer.observe(header);
      observer.observe(bar);
    } else {
      window.addEventListener('resize', publishHeight, { passive: true });
    }
  }

  function initFloatingContactSafety() {
    var bubble = document.querySelector('.whatsapp-chat-bubble');
    if (!bubble || !document.elementsFromPoint) return;
    var scheduled = false;

    function update() {
      scheduled = false;
      var style = window.getComputedStyle(bubble);
      if (style.display === 'none' || style.visibility === 'hidden') return;
      var rect = bubble.getBoundingClientRect();
      var safetyGap = 7;
      var safeRect = {
        left: rect.left - safetyGap,
        right: rect.right + safetyGap,
        top: rect.top - safetyGap,
        bottom: rect.bottom + safetyGap
      };
      var actionables = document.querySelectorAll(
        'a[href], button, input, select, textarea, summary, [role="button"]'
      );
      var obstructsAction = Array.prototype.some.call(actionables, function (element) {
        if (element === bubble || bubble.contains(element)) return false;
        var actionStyle = window.getComputedStyle(element);
        if (
          actionStyle.display === 'none' ||
          actionStyle.visibility === 'hidden' ||
          actionStyle.pointerEvents === 'none'
        ) return false;
        var actionRect = element.getBoundingClientRect();
        if (actionRect.width < 1 || actionRect.height < 1) return false;
        return !(
          actionRect.right <= safeRect.left ||
          actionRect.left >= safeRect.right ||
          actionRect.bottom <= safeRect.top ||
          actionRect.top >= safeRect.bottom
        );
      });
      bubble.classList.toggle('is-obstructing', obstructsAction);
    }

    function schedule() {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(update);
    }

    update();
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    window.addEventListener('load', schedule, { once: true });
    document.addEventListener('click', function () {
      schedule();
      window.setTimeout(schedule, 220);
    });
    document.addEventListener('shopify:section:load', schedule);
    window.setTimeout(schedule, 250);
    window.setTimeout(schedule, 1000);
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(schedule);
    }
    if ('ResizeObserver' in window && document.body) {
      var contactObserver = new ResizeObserver(schedule);
      contactObserver.observe(document.body);
    }
    if ('MutationObserver' in window && document.documentElement) {
      var contactMutationObserver = new MutationObserver(schedule);
      contactMutationObserver.observe(document.documentElement, {
        attributes: true,
        attributeFilter: ['class', 'style', 'open', 'aria-hidden'],
        childList: true,
        subtree: true
      });
    }
  }

  function init() {
    initReveal();
    initNav();
    initHeaderMetrics();
    initFloatingContactSafety();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();
